import { render, staticRenderFns } from "./RequerimientoAttachmentsNone.vue?vue&type=template&id=4e7850d7&scoped=true&"
import script from "./RequerimientoAttachmentsNone.vue?vue&type=script&lang=js&"
export * from "./RequerimientoAttachmentsNone.vue?vue&type=script&lang=js&"
import style0 from "./RequerimientoAttachmentsNone.vue?vue&type=style&index=0&id=4e7850d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7850d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {
  VDataTable,
})
